import { ParentContext } from 'global/cnr/contexts/ParentContext'
import UiSaveButtons from 'global/components/buttons/UiSaveButtons'
import { listYears } from 'global/lists/lists'
import { openExternal } from 'global/viewSettings/helpers/settingsLinks'
import ItemMenuSquares, { _imsTypes } from 'global/wrappers/ItemMenuSquares'
import TransitionWrapper from 'global/wrappers/TransitionWrapper'
import Wrapper, { wrapperTypes } from 'global/wrappers/Wrapper'
import WrapperVertCols from 'global/wrappers/WrapperVertCols'
import _ from 'lodash'
import { SportsDistrictContext } from 'projectSpecific/sports/cnr/contexts/SportsDistrictContext'
import { _sportsFormProps, SportsSeasonContext } from 'projectSpecific/sports/cnr/contexts/SportsSeasonContext'
import { _sportCollections } from 'projectSpecific/sports/cnr/reducers/SportsSidebarReducer'
import { _seasonPasteTypes, SeasonPaste } from 'projectSpecific/sports/create/SeasonPaste'
import SportFormProps from 'projectSpecific/sports/create/SportFormProps'
import { _allowSportsUpdates } from 'projectSpecific/sports/useHelpers/useSeasonals'
import { useSportsTeams } from 'projectSpecific/sports/useHelpers/useSportsTeams'
import { useTeamRosters } from 'projectSpecific/sports/useHelpers/useTeamRosters'
import { useContext, useEffect, useMemo, useState } from 'react'
import { Button, Form, Icon, Label } from 'semantic-ui-react'
import { _sdm } from './SportsDashboard'
import { useSportsAccess } from 'projectSpecific/sports/useHelpers/useSportsAccess'
import { _longPressTypes, LPW } from 'global/wrappers/LongPressWrapper'
import RosterBuilder from 'projectSpecific/sports/create/RosterBuilder'
import TeamLinks from 'projectSpecific/sports/create/TeamLinks'
import { AccessSquares } from './AccessSquares'

const _teamDashboardTypes = {
  teamAccess: 'teamAccess',
  googleSheetKeys: 'googleSheetKeys',
  teamLinks: 'teamLinks',
  combinedRoster: 'combinedRoster',
  // fullRoster: 'fullRoster',
  // seasonalRoster: 'seasonalRoster',
  staff: 'staff',
}

const _accessTypes = {
  team: 'team',
  sport: 'sport',
  school: 'school',
  district: 'district',
}

const _sportsAccessTypes = {
  full: 'full',
  edit: 'edit',
  scores: 'scores',
  sport: 'sport',
  school: 'school',
}

export const TeamsDashboard = ({ sportsDataMode }) => {

  const parentContext = useContext(ParentContext);
  const { states, fns } = parentContext ?? {}
  const { paps_state } = states ?? {}
  const { database_fns } = fns ?? {}
  const { pathViews } = paps_state ?? {}

  const sportsDistrictContext = useContext(SportsDistrictContext)
  const { sportsDistrict_state } = sportsDistrictContext ?? {}
  const { schools: schools_district, sports: sports_district } = sportsDistrict_state ?? {}

  const sportsSeasonContext = useContext(SportsSeasonContext)
  const { sportsSeason_state } = sportsSeasonContext ?? {}
  const { currentSeason_info, sportsAccess_teams, gls_teams, teams_info } = sportsSeason_state ?? {}
  const { teams } = teams_info ?? {}
  const { teams: access_teams } = sportsAccess_teams ?? {}
  const { currentSeason } = currentSeason_info ?? {}

  const { updateSportsTeams, getSportsTeams, updating } = useSportsTeams()

  const { updating: updating_roster, allowRosterUpdate, getTeamRosters, updateRoster, getRosters, getStaff } = useTeamRosters()
  const { updating: updating_access, allowAccessUpdate, getAccess, updateAccess } = useSportsAccess()

  const _updating = updating_roster || updating_access || updating

  const [accessByEmail, setAccessByEmail] = useState()
  const [accessByTeams, setAccessByTeams] = useState()
  const [activeAccessItem, setActiveAccessItem] = useState()
  const [activeItem, setActiveItem] = useState()
  const [activeLongPressItem, setActiveLongPressItem] = useState()
  const [activeSchool, setActiveSchool] = useState()
  const [activeSport, setActiveSport] = useState()
  const [activeYear, setActiveYear] = useState()
  const [currentAccessItem, setCurrentAccessItem] = useState()
  const [currentTeam, setCurrentTeam] = useState()
  const [currentTeamDashboardType, setCurrentTeamDashboardType] = useState()
  const [formData_gls, setFormData_gls] = useState(_sportsFormProps[_sdm.sports.googleSheetKeys])
  const [formData_teamLinks, setFormData_teamLinks] = useState(_sportsFormProps[_sdm.sports.teamLinks])
  const [showAddTeam, setShowAddTeam] = useState()
  const [teamAccess, setTeamAccess] = useState()
  const [teamGls, setTeamGls] = useState()
  const [teamName, setTeamName] = useState()
  const [teamsAccess, setTeamsAccess] = useState(access_teams)
  const [teamsExternalLinks, setTeamsExternalLinks] = useState(gls_teams)
  const [teamsGls, setTeamsGls] = useState(gls_teams)
  const [showSports, setShowSports] = useState()
  const [showSchools, setShowSchools] = useState()

  const [allTeamRosters, setAllTeamRosters] = useState({
    seasonal: {},
    teamRosters: {},
    fullRosters: {},
    combinedRosters: {},
    fullStaff: {},
    staff: {},
    rosterKey: null,
    staffKey: null
  })

  const currentTeamRosters = useMemo(() => {
    if (!currentTeam) return;
    const { _itemKey } = currentTeam ?? {}
    const _currentTeamRosters = {
      normal: allTeamRosters.teamRosters?.[_itemKey],
      full: allTeamRosters.fullRosters?.[_itemKey],
      combined: allTeamRosters.combinedRosters?.[_itemKey],
      fullStaff: allTeamRosters.fullStaff?.[_itemKey],
    }
    return _currentTeamRosters
  }, [currentTeam, _.size(allTeamRosters?.combinedRosters?.[currentTeam?._itemKey])])

  const _combinedRoster = allTeamRosters.combinedRosters?.[currentTeam?._itemKey]

  const handleSelect_sport = (item) => {
    const { _itemKey } = item
    setShowSports(!showSports)
    setActiveSport()
    const _accessByEmail = accessByEmail ? _.cloneDeep(accessByEmail) : {}
    const _accessBy_email = _accessByEmail?.[activeLongPressItem?.name] || {}
    if (!_accessBy_email?.sports) { _accessBy_email.sports = {} }
    _accessBy_email.sports[_itemKey] = {
      accessLevel: 'scores'
    }
    setAccessByEmail(_accessByEmail)
  }

  const handleSelect_school = (item) => {
    const { name } = item
    const schoolKey = _.findKey(schools_district, { name })
    setShowSchools(!showSchools)
    setActiveSchool()
    const _accessByEmail = accessByEmail ? _.cloneDeep(accessByEmail) : {}
    const _accessBy_email = _accessByEmail?.[activeLongPressItem?.name] || {}
    if (!_accessBy_email?.schools) { _accessBy_email.schools = {} }
    _accessBy_email.schools[schoolKey] = {
      accessLevel: 'scores'
    }
    setAccessByEmail(_accessByEmail)
  }

  const handleSelect_accessItem = (item) => setActiveAccessItem(item.name)

  const handleUpdate = (updateType) => {
    const { _itemKey } = currentTeam ?? {}
    switch (updateType) {
      case _teamDashboardTypes.teamAccess:
        return;

      case _teamDashboardTypes.teamLinks:
        return;

      // case _teamDashboardTypes.seasonalRoster:
      //   return;

      // case _teamDashboardTypes.fullRoster:
      //   const _fullTeamRoster = allTeamRosters.fullRosters?.[_itemKey]
      //   console.log('_fullRoster', _itemKey, _fullTeamRoster)
      //   updateRoster({ teamKey: _itemKey, roster: _fullTeamRoster })
      //   return;

      case _teamDashboardTypes.combinedRoster:
        const _teamRosterCombined = allTeamRosters.combinedRosters?.[_itemKey]
        updateRoster({ teamKey: _itemKey, roster: _teamRosterCombined })
        return;

      case _teamDashboardTypes.staff:
        return;
    }
  }

  const handleNewRoster = (newRoster) => {

    const { _itemKey } = currentTeam ?? {};

    setAllTeamRosters(prev => {

      const next = _.cloneDeep(prev);

      const combined = next.combinedRosters[_itemKey] ?? {};

      next.combinedRosters[_itemKey] = _.mergeWith(
        {},
        combined,
        newRoster,
        (objValue, srcValue) => {
          if (_.isArray(objValue)) {
            return _.uniq([...objValue, ...srcValue]);
          }
        }
      );

      return next;
    });

  };

  const handleNewStaff = (newRoster) => {
    const { _itemKey } = currentTeam ?? {}
    const _allTeamRosters = _.cloneDeep(allTeamRosters)
    const _fullStaff = allTeamRosters.fullStaff?.[_itemKey]
    // const roster_merged = _.mergeWith({}, _fullStaff, newRoster, (objValue, srcValue) => {
    //   if (_.isArray(objValue)) {
    //     return _.uniq([...objValue, ...srcValue]);
    //   }
    // });
    // const _rostersCombined = _.cloneDeep(_allTeamRosters.combinedRosters)
    // const _rosterCombined = _rostersCombined?.[_itemKey]
    // const roster_combined_merged = _.mergeWith({}, _rosterCombined, newRoster, (objValue, srcValue) => {
    //   if (_.isArray(objValue)) {
    //     return _.uniq([...objValue, ...srcValue]);
    //   }
    // });
    // _rostersCombined[_itemKey] = roster_combined_merged
    // _allTeamRosters.combinedRosters = _rostersCombined
    // setAllTeamRosters(_allTeamRosters) 
  }


  useEffect(() => {

    const cb_teamRosters = ({ parentKey, teamRosters, fullRosters }) => {
      setAllTeamRosters(prev => {
        const combinedRosters = _.cloneDeep(fullRosters);
        return {
          ...prev,
          teamRosters,
          fullRosters,
          combinedRosters,
          rosterKey: parentKey,
        };
      });
    };

    const cb_staff = ({ parentKey, teamStaff, fullStaff }) => {
      setAllTeamRosters(prev => ({
        ...prev,
        fullStaff,
        // staffKey: parentKey,
      }));
    };

    const cb_access = ({ parentKey, teams, accessByEmail, accessByTeams }) => {
      setAccessByEmail(accessByEmail)
      setAccessByTeams(accessByTeams)
    };
    getTeamRosters({ callback: cb_teamRosters })
    getStaff({ callback: cb_staff })
    getAccess({ callback: cb_access })
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const getFormData_teamLinks = (teamKey) => {
    const formProps = _sportsFormProps[_sdm.sports.teamLinks] || {};
    const teamProps = teamsExternalLinks?.[teamKey] || {};
    const normalizedTeamProps = _.omit(
      {
        ...teamProps,
        xLink: teamProps.xLink ?? teamProps.twitterLink,
      },
      "twitterLink",
      "rosterSheet",
      "staffSheet",
      "googleSheetsId",
      "newsSheet",
    );
    return _.defaults({}, normalizedTeamProps, formProps);
  }

  const getFormData_gls = (teamKey) => {
    const formProps = _sportsFormProps[_sdm.sports.googleSheetKeys] || {};
    const teamProps = teamsGls?.[teamKey] || {};
    const normalizedTeamProps = _.omit(
      {
        ...teamProps,
      },
      "twitterLink",
      "xLink",
      "hudlLink",
      "youTubeLink",
    );
    return _.defaults({}, normalizedTeamProps, formProps);
  }


  // if the currentTeam changes...
  useEffect(() => {
    if (!currentTeam) return;

    const { _itemKey } = currentTeam

    // team access
    const access_team = teamsAccess?.[_itemKey]
    setTeamAccess(access_team)

    // team gls
    const gls_team = teamsGls?.[_itemKey]
    setTeamGls(gls_team)

    setFormData_gls(getFormData_gls(_itemKey))
    setFormData_teamLinks(getFormData_teamLinks(_itemKey))
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentTeam, activeYear, allTeamRosters]);

  const handleChangeTeam = (e, { name, value }) => setTeamName(value)

  const handleShowAddTeam = () => {
    setShowAddTeam(!showAddTeam)
    setTeamName()
  }

  const handleSaveTeam = () => {
    const cb = () => {
      setShowAddTeam(false)
    }
    updateSportsTeams({ teamName, callback: cb })
  }

  const fnAlt_years = (item) => {
    const { name: activeYear } = item
    if (activeYear && currentTeamRosters?.combined) {
      const currentRoster = _.pickBy(currentTeamRosters?.combined, player =>
        _.has(player, ["seasons", activeYear])
      );
      return <Label size='tiny' color={!_.isEmpty(currentRoster) ? 'blue' : 'grey'}>{_.size(currentRoster)}</Label>
    }
  }

  const fnAlt_teams = (item) => {
    const { _itemKey, name } = item
    const school = _.find(schools_district, { name })
    const ta = accessByTeams?.[_itemKey]
    const matches = _.pickBy(
      accessByEmail,
      item => item.teams?.[_itemKey]
    );
    const t = {
      // s: allTeamRosters.seasonal?.[_itemKey],
      cr: allTeamRosters.combinedRosters?.[_itemKey],
      fs: allTeamRosters.fullStaff?.[_itemKey],
    }

    switch (sportsDataMode) {
      case _sdm.sports.teamAccess:
      case _sdm.sports.googleSheetKeys:
      case _sdm.sports.teamLinks:
        return <div style={{ display: 'flex', columnGap: '.5em', width: '80px', justifyContent: 'space-between', alignItems: 'center' }}>
          <div>{school?.initials}<Icon style={{ marginLeft: '1em' }} color='green' name={'building outline'} /></div>
          <Label style={{ flex: 1, textAlign: 'center' }} size='mini'><Icon name='key' color={_.isEmpty(matches) ? 'grey' : 'purple'} />{_.size(matches)}</Label>
        </div>
      case _sdm.sports.teamRosters:
        return <div style={{ display: 'flex', columnGap: '.5em', width: '280px', justifyContent: 'space-between', alignItems: 'center' }}>
          <div>{school?.initials}<Icon style={{ marginLeft: '1em' }} color='green' name={'building outline'} /></div>
          <Label style={{ flex: 1, textAlign: 'center' }} size='mini'><Icon name='users' color={_.isEmpty(t.cr) ? 'grey' : 'pink'} />{_.size(t.cr)}</Label>
          {/* <Label style={{ flex: 1, textAlign: 'center' }} size='mini'><Icon name='users' color={_.isEmpty(t.s) ? 'grey' : 'blue'} />{_.size(t.s)}</Label> */}
          <Label style={{ flex: 1, textAlign: 'center' }} size='mini'><Icon name='users' color={_.isEmpty(t.fs) ? 'grey' : 'yellow'} />{_.size(t.fs)}</Label>
        </div>
      default:
        return <div style={{ display: 'flex', columnGap: '.5em', width: '280px', justifyContent: 'space-between', alignItems: 'center' }}>
          <div>{school?.initials}<Icon style={{ marginLeft: '1em' }} color='green' name={'building outline'} /></div>
          <Label style={{ flex: 1, textAlign: 'center' }} size='mini'><Icon name='key' color={_.isEmpty(ta) ? 'grey' : 'purple'} />{_.size(ta)}</Label>
          <Label style={{ flex: 1, textAlign: 'center' }} size='mini'><Icon name='users' color={_.isEmpty(t.cr) ? 'grey' : 'pink'} />{_.size(t.cr)}</Label>
          {/* <Label style={{ flex: 1, textAlign: 'center' }} size='mini'><Icon name='users' color={_.isEmpty(t.s) ? 'grey' : 'blue'} />{_.size(t.s)}</Label> */}
          <Label style={{ flex: 1, textAlign: 'center' }} size='mini'><Icon name='users' color={_.isEmpty(t.fs) ? 'grey' : 'yellow'} />{_.size(t.fs)}</Label>
        </div>
    }

  }

  const content_addTeam = () => {
    return <Wrapper
      header={'Add Team'}
      content={<Form>
        <Form.Input
          label={'Name'}
          name="email"
          value={teamName}
          onChange={handleChangeTeam}
        ></Form.Input>
      </Form>}
      footer={<UiSaveButtons
        save={{ caption: 'Add', oc: handleSaveTeam, icon: 'save', color: 'green' }}
        cancel={{ oc: handleShowAddTeam }}
      />}
      wrapperType={wrapperTypes.padded}
      updating={updating}
    />
  }

  const fnAlt_types = (item) => {
    if (!currentTeam) return;
    const { _itemKey } = currentTeam ?? {}
    const counts = {
      teamAccess: teamsAccess?.[_itemKey],
      externalLinks: teamsExternalLinks?.[_itemKey],
      gls: teamsGls?.[_itemKey],
      rostersCombined: allTeamRosters.combinedRosters?.[_itemKey],
      currentRoster: allTeamRosters.seasonal?.[_itemKey],
      currentStaff: allTeamRosters.fullStaff?.[_itemKey]
    }


    switch (item) {
      case _teamDashboardTypes.teamAccess:
        return <Label size='mini' color={_.isEmpty(counts.teamAccess) ? 'grey' : 'purple'}>{_.size(counts.teamAccess)}</Label>
      case _teamDashboardTypes.googleSheetKeys:
        return <Icon name='check circle outline' color={_.isEmpty(counts.gls) ? 'grey' : 'blue'} />
      case _teamDashboardTypes.teamLinks:
        return <Icon name='check circle outline' color={_.isEmpty(counts.externalLinks) ? 'grey' : 'blue'} />
      case _teamDashboardTypes.combinedRoster:
        return <Label size='mini' color={_.isEmpty(counts.rostersCombined) ? 'grey' : 'pink'}>{_.size(counts.rostersCombined)}</Label>
      // case _teamDashboardTypes.fullRoster:
      //   return <Label size='mini' color={_.isEmpty(counts.fullRoster) ? 'grey' : 'green'}>{_.size(counts.fullRoster)}</Label>
      // case _teamDashboardTypes.seasonalRoster:
      //   if (!activeYear) return;
      //   return <Label size='mini' color={_.isEmpty(currentRoster) ? 'grey' : 'blue'}>{`${activeYear}: ${_.size(currentRoster)}`}</Label>
      case _teamDashboardTypes.staff:
        return <Label size='mini' color={_.isEmpty(counts.currentStaff) ? 'grey' : 'yellow'}>{_.size(counts.currentStaff)}</Label>
    }
  }

  const handle_update = () => {
    switch (currentTeamDashboardType) {
      case _teamDashboardTypes.teamAccess:
        const _teamAccess = accessByTeams?.[currentTeam?._itemKey]
        updateAccess({ teamAccess, teamKey: currentTeam._itemKey, accessByTeam: _teamAccess, accessByEmail })

        break;
      case _teamDashboardTypes.teamLinks:
        break;
    }
  }

  const footer_item = () => {
    switch (currentTeamDashboardType) {
      case _teamDashboardTypes.googleSheetKeys:
        return <UiSaveButtons
          save={{
            oc: handle_update,
            caption: 'Save Google Sheet Keys'
          }}
        />
      // case _teamDashboardTypes.externalLinks:
      //   return <UiSaveButtons
      //     save={{
      //       oc: handle_update,
      //       caption: 'Save GLS'
      //     }}
      //   />
    }
  }

  const handleFormChange = () => {

  }

  const formElements_teamLinks = () => {
    const inputs = []
    if (formData_teamLinks) {
      return <SportFormProps formData={formData_teamLinks} handleFormChange={handleFormChange} />
    }
    return inputs
  }

  const formElements_gls = () => {
    const inputs = []
    if (formData_gls) {
      return <SportFormProps formData={formData_gls} handleFormChange={handleFormChange} />
    }
    return inputs
  }

  const content_form_gls = () => <Form>
    {formElements_gls()}
  </Form>

  const externals = {
    roster: () => openExternal.firebaseDbDirect(pathViews, [_sportCollections._teamRosters, allTeamRosters.rosterKey]),
    // fullRoster: () => openExternal.firebaseDbDirect(pathViews, [_sportCollections._teamRosters, allTeamRosters.rosterKey]),
    staff: () => openExternal.firebaseDbDirect(pathViews, [_sportCollections._teamStaff, allTeamRosters.staffKey]),
  }

  const btn_external = (caption, oc) => <div>
    <Button
      labelPosition='right'
      content={caption}
      size='mini'
      color={'orange'}
      icon='external alternate'
      onClick={() => { oc() }} />
  </div>

  const btn_save = (caption, items, updateType) => <div>
    <Button
      labelPosition='right'
      content={caption}
      size='mini'
      color={_.isEmpty(items) ? 'grey' : allowRosterUpdate ? 'green' : 'teal'}
      icon='save'
      disabled={_.isEmpty(items)}
      onClick={() => { handleUpdate(updateType) }}
    />
  </div>

  const lbl_icn = (icon, value, width) => <Label size='mini' style={{ flex: 1, width: width ? `${width}px` : '40px', textAlign: 'center' }}>
    <Icon name={icon} color={'blue'} />{value}
  </Label>


  const footer_staff = () => <div style={{ display: 'flex', justifyContent: 'space-between' }}>
    {btn_external('Open Staff', externals.staff)}
    {btn_save('Update Staff', currentTeamRosters?.fullStaff)}
  </div>

  const wrapper_teamGoogleSheetKeys = (currentType) => {
    return tw(<Wrapper
      content={content_form_gls()}
      // content={<div>{currentType}</div>}
      wrapperType={wrapperTypes.padded}
      footer={footer_item()}
    >
    </Wrapper>)
  }

  const fnAlt_staff = (item) => {
    const { position } = item ?? {}
    return <div style={{ display: 'flex' }}>
      {lbl_icn('id badge', position, 120)}
    </div>
  }

  const tw = (content) => <TransitionWrapper>
    {content}
  </TransitionWrapper>

  const wrapper_roster_combined = () => {
    let _roster = currentTeamRosters?.combined
    if (activeYear) {
      const currentRoster = _.pickBy(currentTeamRosters?.combined, player =>
        _.has(player, ["seasons", activeYear])
      );
      _roster = currentRoster
    }
    return <RosterBuilder currentTeam={currentTeam} roster={_roster} />
  }

  const wrapper_staff = () => <Wrapper
    header={<SeasonPaste roster={currentTeamRosters?.fullStaff} handle_paste={handleNewStaff} seasonPasteType={_seasonPasteTypes.staff} />}
    content={<ItemMenuSquares
      menuItems={currentTeamRosters?.fullStaff}
      imsType={_imsTypes.inline}
      fn_altContent={fnAlt_staff}
      noItemIcon={true}
    />}
    footer={footer_staff()}
    wrapperType={wrapperTypes.padded}
  ></Wrapper>

  const content_item = () => {
    switch (currentTeamDashboardType) {
      case _teamDashboardTypes.teamAccess:
        return <AccessSquares
          _teamAccess={teamAccess}
          _currentTeam={currentTeam}
          _accessByEmail={accessByEmail}
          _accessByTeams={accessByTeams}
        />

      case _teamDashboardTypes.googleSheetKeys:
        return wrapper_teamGoogleSheetKeys(currentTeamDashboardType)

      case _teamDashboardTypes.teamLinks:
        return <TeamLinks currentTeam={currentTeam} />

      case _teamDashboardTypes.combinedRoster:
        return wrapper_roster_combined()

      case _teamDashboardTypes.staff:
        return wrapper_staff()
    }
  }

  const showYears = useMemo(() => {
    switch (currentTeamDashboardType) {
      case _teamDashboardTypes.combinedRoster:
      // case _teamDashboardTypes.fullRoster:
      // case _teamDashboardTypes.seasonalRoster:
      case _teamDashboardTypes.staff:
        return true
      default:
        return false
    }
  }, [currentTeamDashboardType])

  // YEARS
  const wrapper_years = useMemo(() => {
    const dataMenuItems = listYears(1, 10, false, true)
    const oc = (value) => setActiveYear(activeYear === value.name ? null : value.name)
    return <Wrapper
      header={'Season'}
      content={<ItemMenuSquares
        menuItems={dataMenuItems}
        activeItem={activeYear}
        imsType={_imsTypes.inline}
        onClick={oc}
        noItemIcon={true}
        fn_altContent={fnAlt_years}
      />}
    />
  }, [activeYear, currentTeam])

  // TEAMS
  const wrapper_teams = () => {
    if (showAddTeam) {
      return content_addTeam()
    }
    const handelSelect_team = (team) => {
      setCurrentTeam(team)
      setActiveYear()
    }
    return <Wrapper
      header={<div style={{ display: 'flex', justifyContent: 'space-between' }}>
        <div>{'Teams'}</div>
        <Label size='tiny'>{_.size(teams)}</Label>
      </div>}
      content={<TransitionWrapper>
        <ItemMenuSquares
          menuItems={_.sortBy(teams, 'name')}
          onClick={handelSelect_team}
          activeItem={currentTeam?.name}
          imsType={_imsTypes.inline}
          fn_altContent={fnAlt_teams}
          noItemIcon={true}
        />
      </TransitionWrapper>}
      footer={<UiSaveButtons save={{ caption: 'Add Team', oc: handleShowAddTeam, icon: 'arrow right', color: 'blue' }} />}
      wrapperType={wrapperTypes.paddedFooter}
    ></Wrapper>
  }

  const wrapper_generic = (caption, items, activeItem, oc) => {
    return <Wrapper
      header={<div style={{ display: 'flex', justifyContent: 'space-between' }}>
        <div>{caption}</div>
        <Label size='tiny'>{_.size(items)}</Label>
      </div>}
      content={<TransitionWrapper>
        <ItemMenuSquares
          menuItems={_.sortBy(items, 'name')}
          onClick={oc}
          activeItem={activeItem}
          imsType={_imsTypes.inline}
          // fn_altContent={fnAlt_teams}
          noItemIcon={true}
          ignoreStartCase={true}
        />
      </TransitionWrapper>}
      // footer={<UiSaveButtons save={{ caption: 'Add Team', oc: handleShowAddTeam, icon: 'arrow right', color: 'blue' }} />}
      wrapperType={wrapperTypes.paddedFooter}
    ></Wrapper>
  }

  // TEAM TYPES
  const wrapper_teamTypes = () => {
    const teamName = `${currentTeam?.name || 'Team'}`
    const oc = (type) => setCurrentTeamDashboardType(type)
    const h = activeYear ?
      <div style={{ display: 'flex', justifyContent: 'space-between' }}>
        <div>{teamName}</div>
        <Label size='tiny'>{activeYear}</Label>
      </div>
      :
      <div>{teamName}</div>

    let _tdts = {}

    switch (sportsDataMode) {
      case _sdm.sports.teamAccess:
      case _sdm.sports.googleSheetKeys:
      case _sdm.sports.teamLinks:
        _tdts = _.omit(_teamDashboardTypes, [_teamDashboardTypes.combinedRoster, _teamDashboardTypes.staff])
        break;
      case _sdm.sports.teamRosters:
        _tdts = _.omit(_teamDashboardTypes, [_teamDashboardTypes.googleSheetKeys, _teamDashboardTypes.teamLinks, _teamDashboardTypes.teamAccess])
        break;
      default:
        _tdts = _teamDashboardTypes
    }

    return <Wrapper
      header={h}
      content={<TransitionWrapper>
        <ItemMenuSquares
          menuItems={_tdts}
          onClick={oc}
          activeItem={currentTeamDashboardType}
          imsType={_imsTypes.inline}
          icon={'users'}
          fn_altContent={fnAlt_types}
          noItemIcon={true}
        />
      </TransitionWrapper>}
    ></Wrapper>
  }

  // const wrapper_accessTypes = () => {
  //   const teamName = `${currentTeam?.name || 'Team'}`
  //   const h = activeYear ?
  //     <div style={{ display: 'flex', justifyContent: 'space-between' }}>
  //       <div>{teamName}</div>
  //       <Label size='tiny'>{activeYear}</Label>
  //     </div>
  //     :
  //     <div>{teamName}</div>

  //   return <Wrapper
  //     header={h}
  //     content={<TransitionWrapper>
  //       <ItemMenuSquares
  //         menuItems={_accessTypes}
  //         // onClick={handelSelect_type}
  //         activeItem={currentTeamDashboardType}
  //         imsType={_imsTypes.inline}
  //         icon={'users'}
  //         fn_altContent={fnAlt_types}
  //         noItemIcon={true}
  //       />
  //     </TransitionWrapper>}
  //   ></Wrapper>
  // }

  // TEAM DATA
  const wrapper_teamData = () => {
    let _header = currentTeamDashboardType ? _.startCase(currentTeamDashboardType) : 'Selected Type'
    // switch (currentTeamDashboardType) {
    //   case _teamDashboardTypes.seasonalRoster:
    //     _header = `${_header} (${activeYear || currentSeason})`
    // }
    return <Wrapper
      header={_header}
      content={<TransitionWrapper>
        {content_item()}
      </TransitionWrapper>}
    ></Wrapper>
  }


  const content_all = () => {
    let _mvc = '2-1-3' // 6
    if (showYears) {
      _mvc = '2-1-1-2' // 6
    }
    if (showSports || showSchools) {
      _mvc = '2-1-2-1' // 6
    }
    return <WrapperVertCols mvc={_mvc}  >
      {wrapper_teams()}
      {wrapper_teamTypes()}
      {showYears && wrapper_years}
      {wrapper_teamData()}
      {showSports && wrapper_generic('Sports', sports_district, activeSport, handleSelect_sport)}
      {showSchools && wrapper_generic('Schools', schools_district, activeSchool, handleSelect_school)}
      {/* {wrapper_sports()} */}
    </WrapperVertCols>
  }

  const content_sports = () => <WrapperVertCols mvc={'2'}  >
    {wrapper_generic('Access', accessByEmail, activeAccessItem, handleSelect_accessItem)}
    {wrapper_generic('Sports', sports_district, activeSport, handleSelect_sport)}
    {/* {wrapper_teamTypes()} */}
    {/* {showYears && wrapper_years} */}
    {/* {wrapper_teamData()} */}
    {/* {wrapper_sports()} */}
  </WrapperVertCols>

  const content = () => {
    switch (sportsDataMode) {
      case _sdm.sports.sportsAccess:
        return content_sports()
      // case _sdm.sports.teamRosters

      // case _sdm.sports.googleSheetKeys:
      // case _sdm.sports.teamLinks:
      //   _tdts = _.omit(_teamDashboardTypes, [_teamDashboardTypes.combinedRoster,   _teamDashboardTypes.seasonalRoster, _teamDashboardTypes.staff])
      //   break;
      // default:
      //   _tdts = _teamDashboardTypes
    }
    return content_all()
  }

  return (
    content()
  )
}
